/**
 * Observable 10: a modern categorical palette designed for clear
 * differentiation, color-vision tolerance, and light/dark backgrounds.
 */
export const CATEGORICAL_CHART_COLORS = [
  '#4269D0', // blue
  '#EFB118', // amber
  '#FF725C', // coral
  '#6CC5B0', // cyan
  '#3CA951', // green
  '#FF8AB7', // pink
  '#A463F2', // purple
  '#97BBF5', // light blue
  '#9C6B4E', // brown
  '#9498A0', // cool gray
] as const;
